module.exports = __webpack_public_path__ + "static/media/6-seo-new.60c10654.png";